var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ribbon ribbon-top-left"},[_c('span',[_c('p',[_vm._v(_vm._s(_vm.$mode)),_c('br'),_vm._v(_vm._s(_vm.$company.fullName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }